import { UrlApi } from "../../../services/apirest";
import { buildQueryParams } from "../../../utils/buildQueryParams";

export const getSemaforo = async (filtros) => {
  const queryParams = buildQueryParams(filtros);
  const response = await fetch(`${UrlApi}/semaforo?${queryParams}`);

  if (!response.ok)
    throw new Error("Ocurrio un error al obtener los datos del semaforo");

  const result = await response.json();

  return result.data;
};
